"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useImage = void 0;
var React = __importStar(require("react"));
var useImage = function (src) {
    var _a = React.useState(false), hasLoaded = _a[0], setHasLoaded = _a[1];
    React.useEffect(function () {
        if (!src)
            return undefined;
        var image = new Image();
        image.src = src;
        var handleLoad = function () {
            setHasLoaded(true);
        };
        image.onload = handleLoad;
        return function () {
            image.removeEventListener('load', handleLoad);
        };
    }, [src]);
    return { hasLoaded: hasLoaded };
};
exports.useImage = useImage;
//# sourceMappingURL=useImage.js.map